import { PeriodicElement } from '../../vergastos.component';
import { AdminGuardService } from '../../../../servicios/guards/admin-guard.service';
import { Component, ElementRef, Input, OnInit, ViewChild, OnChanges, DoCheck } from '@angular/core';
import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog} from '@angular/material';

import {SelectionModel} from '@angular/cdk/collections';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";

import { AuthService } from '../../../../servicios/auth.service';
import { UserGuardService } from '../../../../servicios/guards/user-guard.service';
import { MultiUserGuardService } from '../../../../servicios/guards/multi-user.service';

import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
import { Router } from '@angular/router';
import { environment } from "environments/environment";
import { GLOBALService } from "../../../../servicios/functions/GLOBAL.service";


export interface PeriodicElement {
  COD_DETALLE:string;
  FECHA_CARGA: string;
  FECHA_TICKET: string;
  DETALLE: string;
  IMPORTE: string;
  CATEGORIA: string;
  OBSERVACIONES: string;
}
var ELEMENT_DATA: PeriodicElement[] = [];
@Component({
  selector: 'app-verdetalle',
  templateUrl: './verdetalle.component.html',
  styleUrls: ['./verdetalle.component.css']
})

export class VerdetalleComponent implements OnInit, DoCheck {
  codgas;
  coddet;
  dataSource = [];

  COD_DETALLE:string;
  FECHA_CARGA: string;
  FECHA_TICKET: string;
  DETALLE: string;
  IMPORTE: string;
  CATEGORIA: string;
  OBSERVACIONES: string;
  
  result;

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe, 
    private router: Router,
    private global: GLOBALService
    ) {


     }

    idsec;
  dataSourceCategorias;
  
  llenarCategorias(){
    //http://localhost:1337/api/llenarcategorias/ver?rol=PAGADOR
    this.http.get(`${environment.backendUrl}/api/llenarcategorias/ver?rol=${this.role}`)
    .subscribe((data: any[]) => {
      this.dataSourceCategorias=data;
      console.log(this.dataSourceCategorias); 
    });

  }

  transformDate(date) {
    this.datePipe.transform(this.FECHA_CARGA, 'yyyy-MM-dd'); //whatever format you need. 
  }
  role;
  ngOnInit() {
    
    this.role=localStorage.getItem('role');
    this.llenarCategorias();
    this.codgas=localStorage.getItem('codgasto_edit');
    this.coddet=localStorage.getItem('coddetalle_edit');
    
    this.http.get(`${environment.backendUrl}/api/vergastos/detalle_edit?coddet=${this.coddet}`)
    .subscribe((data: any[]) => {
      this.dataSource = data;
    this.COD_DETALLE = this.dataSource[0]["COD_DETALLE"]; 
    this.FECHA_CARGA = this.datePipe.transform( this.dataSource[0]["FECHA_CARGA"],"yyyy-MM-dd" );  
    this.FECHA_TICKET = this.datePipe.transform( this.dataSource[0]["FECHA_TICKET"],"yyyy-MM-dd" );  
    this.DETALLE = this.dataSource[0]["DETALLE"];  
    this.IMPORTE = this.dataSource[0]["IMPORTE"];  
    this.CATEGORIA = this.dataSource[0]["CATEGORIA"];  
    this.OBSERVACIONES = this.dataSource[0]["OBSERVACIONES"];  

    console.log(`COD_DETALLE: ${this.dataSource[0]["COD_DETALLE"]}`);  
    console.log(`FECHA_CARGA: ${this.dataSource[0]["FECHA_CARGA"]}`);  
    console.log(`FECHA_TICKET: ${this.dataSource[0]["FECHA_TICKET"]}`);  
    console.log(`DETALLE: ${this.dataSource[0]["DETALLE"]}`);  
    console.log(`IMPORTE: ${this.dataSource[0]["IMPORTE"]}`);  
    console.log(`CATEGORIA: ${this.dataSource[0]["CATEGORIA"]}`);  
    console.log(`OBSERVACIONES: ${this.dataSource[0]["OBSERVACIONES"]}`);  
    
    });
  }

  ngDoCheck(){
    console.log("cambios!!");
  }


  volver(){
    localStorage.removeItem('coddetalle_edit');
    this.codgas = null;
    console.log("borro el cod_detalle to_edit");
  }

  eliminarDetalle(){
    
    this.http.get(`${environment.backendUrl}/api/eliminardetalle/detalle_mata?coddet=${this.coddet}`)
    .subscribe((data: any) => {
      this.result = JSON.stringify(data["affectedRows"]);
      if (this.result==1){
        console.log(`DETALLE COD: ${this.coddet} eliminado correctamente de la bd!`);
        this.global.historicalTo("-ELIMINA DETALLE COD ["+this.coddet+"] del GASTO COD ["+this.codgas+"], det: " + this.DETALLE+ ", a las : " + this.global.horario(),'ELIMINA-GASTO');
      }else{
        console.log(`el COD: ${this.coddet} no existe en la bd!`)
      }
    });
  
    /*
      por POST CRASHEA EL FRONT, PERO EL BACK NO, 
      this.http.post(`${environment.backendUrl}/api/eliminardetalle/detalle_eliminar`, 
      {
        'coddet': this.coddet
      }
      ).subscribe(() => {
        console.log("Eliminado!");     
        location.reload();
      });

      */
      
    localStorage.removeItem('coddetalle_edit');
  }

  updateDetalle(){
    
    this.http.get(`${environment.backendUrl}/api/updatedetalle/detalle_upd?coddet=${this.coddet}&fecha_ticket=${this.FECHA_TICKET}&detalle=${this.DETALLE}&importe=${this.IMPORTE}&categoria=${this.CATEGORIA}&observaciones=${this.OBSERVACIONES}`)
    .subscribe((data: any) => {
      this.result = JSON.stringify(data["affectedRows"]);
      if (this.result==1){
        console.log(`DETALLE COD: ${this.coddet} ** ACTUALIZADO ** correctamente de la bd!`);
        this.global.historicalTo("UPDATE, realizo cambios en el GASTO COD [" + this.codgas+ "], DETALLE COD: ["+this.coddet+"], det: " + this.DETALLE+ ", a las : " + this.global.horario(),'UPDATE-GASTO');
        this.router.navigate(['/verdetalles']);     
      }else{
        console.log(`el COD: ${this.coddet} ** NO ** existe en la bd!`)
      }
    });

    localStorage.removeItem('coddetalle_edit');
  }

}
    